import api from '@/api'
import Vue from 'vue'

const state = {
  proveedores: []
}

const getters = {
  proveedores: (state) => state.proveedores
}

const mutations = {
  SET_PROVEEDORES (state, proveedores) {
    state.proveedores = proveedores
  }
}

const actions = {
  async fetchProveedores ({ commit }) {
    try {
      const response = await api.proveedor.getProveedores()
      commit('SET_PROVEEDORES', response.data)
    } catch (error) {
      console.error('Error al obtener proveedores:', error)
      throw error
    }
  }
}
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
